import window from "../../../lib/WindowExtended";
import {getShopId} from "../../../lib/getShopId";
import {UrlSearchParamsHelper} from "../../../../helpers/urlSearchParamsHelper";
import {IItemSearchResponse, ProductList} from "../../../../typescript-library";

/**
 * Adds up the search query as a `q` parameter, as well as `promotion`
 * param and `na`param (related to new PA search A-B testing)
 * @param instance
 */
export const searchListRequestParams = (instance: ProductList): URLSearchParams => {
  const reqParam = new URLSearchParams(instance.requestParams);
  Object.keys(instance.requestParams).forEach((rqp) => {
    if (!instance.requestParams[rqp]) {
      reqParam.delete(rqp);
    }
  });
  reqParam.delete("categoryId");

  const searchQuery = new URLSearchParams(window.location.search).get("q");
  if (searchQuery) reqParam.append("q", searchQuery);

  if (getShopId() === 100001 && window.c_EvenOdd === "even") reqParam.append("na", "true");

  if (UrlSearchParamsHelper.promotions?.id) reqParam.append("promotionId", `${UrlSearchParamsHelper.promotions.id}`);

  return reqParam;
};

export const searchListFetch = async (
  instance: ProductList,
  reqParam: URLSearchParams,
  token: string | null,
): Promise<IItemSearchResponse> => {
  const headers: HeadersInit = {"Content-Type": "application/json"};
  if (token) headers.Authorization = `Bearer ${token}`;

  const getUrl = `${__API_URL__}/shop/${getShopId()}/search?${reqParam.toString()}`;

  return await fetch(getUrl, {headers})
    .then(
      (resp) =>
        resp.json() as Promise<{
          success: boolean;
          result: IItemSearchResponse;
        }>,
    )
    .then((response) => {
      return response.result;
    });
};
